import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import {
    TextField,
    MenuItem,
    InputAdornment,
    Modal,
    Box
} from "@mui/material";
import Swal from "sweetalert2";
// import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";

const AgregarContactoModal = ({ open, onClose, idRegistro, update = null }) => {
    const [ContactoNuevo, setContactoNuevo] = useState({
        idRegistro: idRegistro,
        valor: ""
    });
    // console.log(ContactoNuevo)

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        if (!open) {
            return
        }
        onExecute();
    }, [open]);

    const onExecute = () => {
        setLoader({ ...loader, mostrar: true });

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`DashboardPostventa/GetTelefonoServicio?id_registro=${idRegistro}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setContactoNuevo(prev => ({
                        ...prev,
                        valor: result.contacto
                    }));
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const guardarContacto = () => {
        if (ContactoNuevo.valor === "" || ContactoNuevo.valor === null || ContactoNuevo.valor === undefined) {
            Swal.fire({
                title: "AGREGAR CONTACTO",
                text: "SE NECESITA AGREGAR UN NUMERO DE TELEFONO",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }

        setLoader({ ...loader, mostrar: true });

        const post = {
            id_registro: idRegistro,
            contacto: ContactoNuevo.valor
        };

        request
            .post(
                `DashboardPostventa/AgregarContactoServiciosPendientes`, post
            )
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                setContactoNuevo({
                    ...ContactoNuevo,
                    valor: "",
                })
                await Swal.fire({
                    title: "AGREGAR CONTACTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });

                if (update !== null) {
                    update()
                }

                onClose();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SERVICIOS PENDIENTES", JSON.stringify(error), "error");
            });
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div className="plantilla-screen-filtro-container-modal-container">
                <div className="agregar-contacto-cotizaciones-modal">
                    <div className="agregar-contacto-modal-detalle">
                        <div className="agregar-contacto-modal-detalle-formulario">
                            <div className="agregar-contacto-modal-formulario-plantilla">
                                <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                                    <PlantillaScreen
                                        titulo={`Registrar Datos de Contacto`}
                                        className_main={1}
                                        className={"plantilla-screen-filtro-container-modal"}
                                    >
                                        <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                        <div
                                            className={`agregar-contacto-modal-formulario-plantilla-agregar`}
                                        >
                                            <div className="agregar-contacto-modal-formulario-plantilla-container scroll-4">
                                                <TextField
                                                    id="outlined-multiline-static"
                                                    size="small" // Añade size="small" aquí
                                                    label={"Teléfono"}
                                                    value={ContactoNuevo.valor}
                                                    onChange={(e) => {
                                                        setContactoNuevo({
                                                            ...ContactoNuevo,
                                                            valor: e.target.value,
                                                        });
                                                    }}
                                                    inputProps={{
                                                        type: 'number',
                                                        style: { height: '20px' },
                                                        onInput: (e) => {
                                                            if (ContactoNuevo.mediocontacto === "T" || ContactoNuevo.mediocontacto === "W") {
                                                                const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                                // Limitar longitud a 10
                                                                if (value.length <= 10) {
                                                                    e.target.value = value;
                                                                } else {
                                                                    e.target.value = value.slice(0, 10);
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    sx={{ flex: 1, mt: 1 }}
                                                />
                                            </div>
                                            <div className="agregar-contacto-modal-buttons">
                                                <button
                                                    className="agregar-contacto-modal-button-guardar"
                                                    onClick={() => guardarContacto()}
                                                >
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </PlantillaScreen>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};


export default AgregarContactoModal;